<template>
  <div
    id="notices"
    class="bg-circle bg-circle-volume"
    @click="handleCickForNotice"
  >
    <img
      class="responsive-icon"
      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1tZWdhcGhvbmUtaWNvbiBsdWNpZGUtbWVnYXBob25lIj48cGF0aCBkPSJNMTEgNmExMyAxMyAwIDAgMCA4LjQtMi44QTEgMSAwIDAgMSAyMSA0djEyYTEgMSAwIDAgMS0xLjYuOEExMyAxMyAwIDAgMCAxMSAxNEg1YTIgMiAwIDAgMS0yLTJWOGEyIDIgMCAwIDEgMi0yeiIvPjxwYXRoIGQ9Ik02IDE0YTEyIDEyIDAgMCAwIDIuNCA3LjIgMiAyIDAgMCAwIDMuMi0yLjRBOCA4IDAgMCAxIDEwIDE0Ii8+PHBhdGggZD0iTTggNnY4Ii8+PC9zdmc+"
      alt="Notices"
    >
    <span
      v-if="isActiveBanner"
      class="notification-badge"
    >1</span>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const bannerRepository = RepositoryFactory.get('banner')

export default {
  name: 'MyBlinkingTooltip',
  data() {
    return {
      isActiveBanner: false,
    }
  },
  async created() {
    await this.fetchBannerData()
  },
  methods: {
    async fetchBannerData() {
      try {
        const bannerDataResponse = await bannerRepository.getActiveBannerAuth()
        this.bannerData = bannerDataResponse.data.data
        if (this.bannerData && this.bannerData.length > 0) {
          this.isActiveBanner = true
        } else {
          this.isActiveBanner = false
        }
      } catch (e) {
        // this.convertAndNotifyError(e)
      }
    },
    handleCickForNotice() {
      this.$router.push('/notices')
    },
  },
}
</script>

<style scoped>
/* 1. Parent Wrapper */
.bg-circle-volume {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  cursor: pointer;
  padding: 8px; /* Keeps background circle proportional */
}

/* 2. Desktop Defaults */
.responsive-icon {
  width: 20px;
  height: 20px;
  display: block;
  object-fit: contain;
}

.notification-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  transform: translate(30%, -30%);
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1;
  background-color: #ea5455;
  border-radius: 9999px;
  color: #fff;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  pointer-events: none;
  z-index: 2;
}

/* 4. Mobile View (<= 768px) */
@media (max-width: 768px) {
  .bg-circle-volume {
    padding: 5px;
  }

  .responsive-icon {
    width: 15px;
    height: 15px;
  }

  .notification-badge {
    min-width: 1rem;
    height: 1rem;
    font-size: 0.6rem;
    padding: 0 0.25rem;
    transform: translate(15%, -20%);
  }
}
</style>
